module.exports = __webpack_public_path__ + "img/image157.dd452fe0.jpg";